import { getLocalizedPath } from './i18n-routes';

/**
 * Convert a string to a URL-friendly slug
 * @param text - The text to slugify
 * @returns A URL-friendly slug
 */
export const slugify = (text: string): string => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')           // Replace spaces with hyphens
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple hyphens with single hyphen
    .replace(/^-+/, '')              // Trim hyphens from start
    .replace(/-+$/, '');             // Trim hyphens from end
};

/**
 * Generate exam URL with slug
 * @param examId - The exam ID
 * @param examName - The exam name
 * @param lang - Optional language code for SEO-friendly URLs. If not provided, uses current language from localStorage
 * @returns URL path like /exam/123/aws-solutions-architect-associate or /fr/exam/123/aws-solutions-architect-associate
 */
export const getExamUrl = (examId: number, examName: string, lang?: string): string => {
  const slug = slugify(examName);
  const path = `/exam/${examId}/${slug}`;
  
  // If lang is not provided, try to get it from localStorage (set by i18next)
  const currentLang = lang || (typeof window !== 'undefined' ? localStorage.getItem('i18nextLng') || 'en' : 'en');
  return getLocalizedPath(path, currentLang);
};
